import React from 'react';
import { Typography } from '@mui/material';
import Card from '../config/ChowaCard';

const ModelRegistrationCard = ({ totalUnits, seriesColor }) => {

  return (
    <Card style={{ padding: '24px', textAlign: 'center', borderRadius: '16px', borderColor: seriesColor, borderWidth: '2px' }}>
      <Typography variant="h6" sx={{ mb: 2, color: seriesColor, fontWeight: 600 }}>
        UNIT登録台数
      </Typography>
      <Typography variant="h4" sx={{ fontWeight: 600, color: seriesColor }}>
        {totalUnits}台
      </Typography>
    </Card>
  );
};

export default ModelRegistrationCard; 